/**
 * theme/shadows.ts
 * Exactly two elevated surfaces exist in this design — the modal and the
 * ledger drawer. Nothing else casts a shadow, so there is no `shadow.sm`.
 * Each export carries both the web box-shadow and the native elevation.
 */
import { Platform, type ViewStyle } from 'react-native';

/** modal — `0 20px 50px -18px rgba(0,0,0,0.5)` */
export const modalShadow: ViewStyle = Platform.select({
  web: { boxShadow: '0 20px 50px -18px rgba(0,0,0,0.5)' } as unknown as ViewStyle,
  ios: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 20 },
    shadowOpacity: 0.28,
    shadowRadius: 25,
  },
  default: { elevation: 16 },
}) as ViewStyle;

/** drawer — `-18px 0 42px -28px rgba(0,0,0,0.4)` */
export const drawerShadow: ViewStyle = Platform.select({
  web: { boxShadow: '-18px 0 42px -28px rgba(0,0,0,0.4)' } as unknown as ViewStyle,
  ios: {
    shadowColor: '#000',
    shadowOffset: { width: -18, height: 0 },
    shadowOpacity: 0.2,
    shadowRadius: 21,
  },
  default: { elevation: 12 },
}) as ViewStyle;

export const shadows = { modal: modalShadow, drawer: drawerShadow } as const;
